import { FC } from 'react'
import { Elements, useElements } from '@stripe/react-stripe-js'
import { getStripe, setElements, STRIPE_OPTIONS } from 'helpers/stripeHelpers'

type StripeRootProps = {}

export const StripeRoot: FC<StripeRootProps> = (props) => {
  const { children } = props
  const stripePromise = getStripe()

  return (
    <Elements stripe={ stripePromise } options={ STRIPE_OPTIONS }>
      <StripeElements>
        { children }
      </StripeElements>
    </Elements>
  )
}

const StripeElements: FC<{}> = (props) => {
  const { children } = props

  const elements = useElements()
  setElements(elements)

  return (
    <>
      { children }
    </>
  )
}
